import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  settings: {
    id: 't.settings',
    defaultMessage: 'Settings',
  },
  updateAccount: {
    id: 't.updateAccount',
    defaultMessage: 'Account',
  },
  notifications: {
    id: 't.notifications',
    defaultMessage: 'Notifications',
  },
  contentSettings: {
    id: 't.contentSettings',
    defaultMessage: 'Content Settings',
  },
  upgrade: {
    id: 't.upgrade',
    defaultMessage: 'Upgrade',
  },
  getPremium: {
    id: 't.getPremium',
    defaultMessage: 'Get Premium',
  },
  subscription: {
    id: 't.subscription',
    defaultMessage: 'Subscription',
  },
  redeem: {
    id: 't.redeem',
    defaultMessage: 'Redeem',
  },
  downloadApp: {
    id: 't.downloadApp',
    defaultMessage: 'Download App',
  },
} as const);
